import { authenticatedFetch } from '../../api/request';

export default async function getDoctorAvailabilities({ idDoctorUser, idDoctorProfile, startDate, endDate, setError }) {
   const onFail = () => setError('Error obteniendo fechas disponibles');

   return await authenticatedFetch(
    `/search-doctors/get-availabilities?idDoctorUser=${idDoctorUser}&idDoctorProfile=${idDoctorProfile}&startDate=${startDate}&endDate=${endDate}`, onFail
   );
}
